import { useRef } from "react";
import { Minus, Plus } from "lucide-react";
import { DraftNumber } from "@/components/kit";
import { useT } from "@/lib/i18n";
import { METRIC, UNIT, toShown, fromShown } from "@/lib/units";

function HoldButton({ testID, onStep, children, label }) {
  const timer = useRef(null);
  const stop = () => { clearTimeout(timer.current); clearInterval(timer.current); };
  const start = (e) => {
    e.preventDefault();
    onStep();
    timer.current = setTimeout(() => { timer.current = setInterval(onStep, 90); }, 420);
  };
  return (
    <button type="button" className="stepper-btn" data-testid={testID} aria-label={label}
      onPointerDown={start} onPointerUp={stop} onPointerLeave={stop} onPointerCancel={stop}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onStep()}>
      {children}
    </button>
  );
}

export function Stepper({ testID, value: rawValue, onValue: rawOnValue, step: rawStep, min: rawMin = 0, max: rawMax = Infinity, decimal: rawDecimal, unit, blank }) {
  const u = METRIC && UNIT[unit];
  const value = toShown(rawValue, unit);
  const onValue = (v) => rawOnValue(fromShown(Math.min(v, u ? rawMax * u.f : rawMax), unit));
  const step = u ? u.step : rawStep;
  const max = u ? rawMax * u.f : rawMax;
  const min = u ? rawMin * u.f : rawMin;
  const decimal = u ? u.dec > 0 : rawDecimal;
  const ref = useRef(value);
  const t = useT();
  ref.current = value;
  const bump = (d) => {
    const next = step < 1 ? Math.round((ref.current + d) / step) * step : ref.current + d;
    const v = Math.min(max, Math.max(min, Math.round(next * 1000) / 1000));
    ref.current = v;
    onValue(v);
  };
  return (
    <div className="stepper" data-testid={`${testID}-stepper`}>
      <HoldButton testID={`${testID}-minus`} label={t("Decrease")} onStep={() => bump(-step)}><Minus size={20} /></HoldButton>
      <DraftNumber testID={testID} decimal={decimal} value={value} onValue={onValue} className="stepper-input" blank={blank} placeholder={blank ? t("Type it") : undefined} />
      {u && <span className="stepper-unit" data-testid={`${testID}-unit`}>{u.label}</span>}
      <HoldButton testID={`${testID}-plus`} label={t("Increase")} onStep={() => bump(step)}><Plus size={20} /></HoldButton>
    </div>
  );
}
